import { computed, watch } from 'vue'

import { useMyProjectRequestLazyQuery, useProjectQuery } from '~/shared/api'
import { isProjectRequestRouteQuery } from '~/shared/const'

import { useProjectRouteRef } from './useProjectRouteRef'

export function useTemplateEditProjectOrRequestMeta() {
  const route = useRoute()
  const { projectId, routeParamForLinks } = useProjectRouteRef(route)

  const isProjectRequestContext = computed(() => isProjectRequestRouteQuery(route.query))

  const projectRequestIdFromRoute = computed(() =>
    isProjectRequestContext.value ? (route.params.id as string) : undefined,
  )

  const { result: projectData } = useProjectQuery(
    () => ({ id: projectId.value }),
    () => ({
      enabled: !isProjectRequestContext.value && Boolean(projectId.value),
      fetchPolicy: 'cache-and-network',
    }),
  )

  const { result: requestData, load: loadMyProjectRequest } = useMyProjectRequestLazyQuery(
    undefined,
    { fetchPolicy: 'cache-and-network' },
  )

  watch(
    projectRequestIdFromRoute,
    async (id) => {
      if (!id) {
        return
      }
      await loadMyProjectRequest(null, { id })
    },
    { immediate: true },
  )

  const resolvedProjectTitle = computed(
    () => projectData.value?.project?.name ?? requestData.value?.request?.name ?? '',
  )

  return {
    isProjectRequestContext,
    resolvedProjectTitle,
    projectData,
    requestData,
    projectId,
    routeParamForLinks,
  }
}
